export const nextFlowInputMap = {
  "check-box": "Toggle",
  "drop-down": "SelectField",
  range: "Slider",
  input: "TextBox"
};
